var map = {
	"./anm-card.png": 1214,
	"./arrow.png": 1215,
	"./arrow.webp": 1216,
	"./asset-1.svg": 1217,
	"./bg-exclusive.webp": 1218,
	"./boost.svg": 1219,
	"./brand-logo-cny.png": 1220,
	"./brand-logo-raya.webp": 1221,
	"./brand-logo.png": 113,
	"./brand-logo.webp": 1222,
	"./btn-black-m.webp": 1223,
	"./btn-blue-m-v2.png": 1224,
	"./btn-blue-m.png": 1225,
	"./btn-blue-m.webp": 1226,
	"./btn-white-m-v2.png": 1227,
	"./btn-white-m.png": 1228,
	"./check-btn.webp": 1229,
	"./default-bg.webp": 1230,
	"./deposit.webp": 1231,
	"./drop-more-btn.webp": 1232,
	"./duitnow.svg": 1233,
	"./eeziepay.svg": 1234,
	"./fcl.svg": 1235,
	"./fcl.webp": 1236,
	"./fpx-logo.svg": 1237,
	"./game-blue.png": 1238,
	"./game-img.png": 1239,
	"./game-white.png": 1240,
	"./global-language.svg": 1241,
	"./grabpay.svg": 1242,
	"./ifm-logo.svg": 1243,
	"./ifm-logo.webp": 1244,
	"./modal-bg.jpg": 1245,
	"./number-bg.webp": 1246,
	"./pagcor.svg": 1247,
	"./pagcor.webp": 1248,
	"./pool-bg.webp": 1249,
	"./promo-given.webp": 1250,
	"./side-bar-bg.png": 1251,
	"./spotlight-base.svg": 1252,
	"./spotlight.svg": 1253,
	"./tether.svg": 1254,
	"./title-asset.svg": 1255,
	"./tng.svg": 1256,
	"./winner.webp": 1257,
	"./withdrawal.webp": 1258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;